import React from 'react';
import { motion } from 'framer-motion';
const LOGOS = ['Shopify', 'Notion', 'Ramp', 'Linear', 'Vercel', 'Stripe', 'Figma', 'Brex', 'Retool', 'Webflow', 'Mercury', 'Loom'];
export function LogoWall() {
  return <section className="w-full bg-white py-16 md:py-20 border-b border-neutral-200" data-id="element-3681" data-mp="3ogpm72e6vm0y">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-3682" data-mp="3sh033a3irwul">
        <div className="flex flex-col items-center justify-center mb-10" data-id="element-3683" data-mp="3sff8jkh7gdwq">
          <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#FFEDD5] mb-3 shadow-sm" data-id="element-3684" data-mp="k27xmzq7f7v9">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/c9cswf4udjck7zyoebqqwd/63a18a4c-5d20-4ad2-ba5f-9334c775fe47/Vector.png" alt="Giga" className="w-6 h-6 object-contain [filter:brightness(0)_saturate(100%)_invert(60%)_sepia(60%)_saturate(2500%)_hue-rotate(346deg)_brightness(100%)_contrast(96%)]" data-id="element-3685" data-mp="oyouqjfdswkh" />
          </div>
          <h2 className="text-xl md:text-2xl font-title font-medium text-[#2B211A]" data-id="element-3686" data-mp="30rdde3mrxfz6">
            Teams use Giga at some pretty cool places
          </h2>
        </div>

        {/* Scroller */}
        <div className="max-w-5xl mx-auto" data-id="element-3687" data-mp="22gesewa5w0lg">
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-6 md:gap-x-14 md:gap-y-7 opacity-50 grayscale" data-id="element-3688" data-mp="22hpv0srvf2az">
            {LOGOS.map((logo, i) => <motion.div key={logo} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.05
          }} className="text-xl md:text-2xl font-bold font-title tracking-tight text-[#F97316]" data-id="element-3689" data-mp="2cd9nt6b51kvi" data-mpi={i}>
                {logo}
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}